import React from "react";
import { NavLink } from "react-router-dom";

const WorkCard = (props) => {
  return (
    <div className="project-card">
      <img src={props.imgsrc} alt="project" />
      <h2 className="project-title">{props.title}</h2>
      <div className="pro-details">
        <p>{props.text}</p>

        {props.subText?.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: "0.75rem",
              color: "aliceblue",
              fontSize: "0.95rem",
              lineHeight: "1.4",
            }}
          >
            <span
              style={{
                marginRight: "0.75rem",
                color: "#4a90e2",
                fontWeight: "bold",
              }}
            >
              •
            </span>
            {item}
          </div>
        ))}

        <div className="pro-btns">
          <NavLink to={props.view} className="btn">
            View
          </NavLink>
          <NavLink to={props.source} className="btn">
            Source
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default WorkCard;
